import * as React from 'react';
import { EditUtmModalController, EditUtmModalControllerProps } from './EditUtmModal.controller';
import { useUpdateUtmSettingsMutation } from '../../../../models/graphql';
import { gql } from '@apollo/client';

gql`
  mutation UpdateUtmSettings($workspaceId: ID!, $input: UpdateWorkspaceSettingsInput!) {
    updateWorkspaceSettings(workspaceId: $workspaceId, input: $input) {
      id
      campaignTracking
      utm {
        source
        medium
        campaign
        term
        content
      }
    }
  }
`;

export type EditUtmModalApolloProps = Omit<EditUtmModalControllerProps, 'updateUtmSettings'> & {
  // ...
};

export const EditUtmModalApollo = (props: EditUtmModalApolloProps): JSX.Element => {
  const [updateUtmSettings] = useUpdateUtmSettingsMutation();

  const controllerProps: EditUtmModalControllerProps = {
    ...props,
    updateUtmSettings
  };

  return <EditUtmModalController {...controllerProps} />;
};
